//natives
import React, { Component } from 'react';
// import TagManager from 'react-gtm-module';
import Cookies from 'universal-cookie';

//components
import EtiquetasLista from '../childrens/etiquetasLista/.mixins/EtiquetasLista';

//controllers
import Etiquetas_controller from '../../../../../../controllers/etiquetas';

export default class Etiquetas extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            title: 'Etiquetas',
            itensTable: [],
            columns: ['ID','Código'],
            isLoading: true,
            page: 1,
            count: 0,
            limit: 10,
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        //colocar aqui uma forma de decidir se é next ou previos
                        this.changePage(tableState.page+1);
                        break;
                    case 'onChangeRowsPerPage':
                        this.setState({
                            limit: tableState.rowsPerPage,
                            itensTable: []
                        });
                        this.changePage(tableState.page);
                        break;
                }
            }
        }
    }

    componentDidMount() {
        this.changePage(1);

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:etiquetas',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-etiquetas',
        //     }
        // });
    }

    changePage = (page) => {
        
        this.setState({
          isLoading: true,
        });

        this.xhrRequest(page).then(res => {
            this.setState({
                isLoading: false,
                page: page,
                itensTable: res.data,
                count: res.total,
            });
        });

    };

    xhrRequest = () => {

        return new Promise(async (resolve, reject) => {
            
            const cookies = new Cookies();
            var json = JSON.parse(await Etiquetas_controller.getEtiquetas(cookies.get('User-Token'),this.state.page,this.state.limit));
            if (json.status) {

                //prepara dados para tabela
                var arrayItens = [];
                json.itens.forEach(element => {
                    arrayItens.push([
                        element.id,
                        element.codigo,
                    ]);
                });

                const total = json.total;
                var maxRound = 0;
                for (let i = 0; i < total; i+=10) {
                    maxRound++;
                }
                const data = [...Array(maxRound)].reduce(acc => acc.push(...arrayItens) && acc, []);
                
                resolve({data, total});

                this.setState({
                    isLoading: false,
                });

            } else {
                this.child.current.retorno('Erro ao carregar dados!','error');
            }
    
        });

    }

    render() {
        return (<EtiquetasLista {...this}/>);
    }

}